import React from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import clsx from 'clsx';

export type EventTimelineItem = {
  date: string;
  hasSuddenWorsening?: boolean;
};

type EventTimelineProps = {
  title?: string;
  items: EventTimelineItem[];
};

export default function EventTimeline({
  title,
  items,
}: EventTimelineProps) {
  const hasTitle = notEmptyString(title);

  return (
    <div className="rounded-2xl border border-gray-200 bg-stone-50 p-4">
      {hasTitle ? (
        <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-600">
          {title}
        </div>
      ) : null}
      {items.length === 0 ? (
        <div className={clsx('text-xs text-gray-500', { 'mt-3': hasTitle })}>
          No check-ins
        </div>
      ) : (
        <div className={clsx('relative', { 'mt-4': hasTitle })}>
          <div className="absolute left-0 right-0 top-1.5 h-px bg-gray-300" />
          <div className="relative flex justify-between gap-2">
            {items.map((item) => (
              <div
                key={`${item.date}`}
                className="flex min-w-0 flex-1 flex-col items-center gap-1.5"
              >
                <span
                  className={clsx(
                    'relative z-10 h-3 w-3 shrink-0 rounded-full border-2 border-stone-50',
                    {
                      'bg-red-500': item.hasSuddenWorsening,
                      'bg-gray-300': !item.hasSuddenWorsening,
                    },
                  )}
                />
                <span className="text-center text-[11px] text-gray-700">
                  {item.date}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
